import {
  OnInit,
  Component,
  Input,
  ViewContainerRef,
  ViewChild,
  ComponentRef,
  Type,
  ComponentFactory,
  ComponentFactoryResolver,
  ChangeDetectionStrategy
} from "@angular/core";

export interface DynamicComponentInstance {
  model?: any;
}

@Component({
  selector: 'dynamic-component'
  , template: `<span #component></span>`,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DynamicComponent implements OnInit {
  @Input() component: any;
  @Input() model: any;
  @Input() modelName: string = "model";

  @ViewChild('component', { read: ViewContainerRef, static: true })
  _componentTarget: ViewContainerRef;

  /* sirve para el caso de que el component venga en forma de selector */
  static componentSelectorsMap: {[key: string]: Type<any>} = {};

  constructor(private _componentFactoryResolver: ComponentFactoryResolver) {
  }

  ngOnInit() {
      let component: any = this.component;
      if (typeof component == "string") {
          component = DynamicComponent.componentSelectorsMap[component];
      }
      
      let componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(component);
      let componentRef: ComponentRef<DynamicComponentInstance> = this._componentTarget.createComponent(componentFactory, 0);
      componentRef.instance[this.modelName] = this.model;
  }
}